import "../styles/Quisuisje.scss";
/*import  from '../assets/'*/

const Quisuisje = () => {
  return (
    <div className="boxQuisuisje">
      <p className="title">test</p>
    </div>
  );
};

export default Quisuisje;
